import Axios from 'axios';
import router from '../router';
import vuex from '../store';
import Qs from 'qs';
import { ip } from '../config/index';
import { Message } from 'element-ui';

Axios.defaults.withCredentials = true; //让ajax携带cookie

export let instance = Axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? ip : ip
})

let token = window.sessionStorage.getItem('token');
if (token !== null) {
    instance.defaults.headers.common['Authorization'] = token;
    instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
}


// respone拦截器 后端返回401代表token无效或者过期
instance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response.status == 401) {
            Message.error(error.response.data.msg);
            vuex.dispatch("logOut").then(() => {
                router.push({ path: '/' })
            })
        } else if (error.response.status == 400) {
            Promise.reject(error.response)
        } else if (error.response.status == 403) {
            Message.error(error.response.data.msg);
            Promise.reject(error.response)
        } else if (error.response.status == 410) {
            Promise.reject(error.response)
        }
        return Promise.reject(error.response)
    }
)

export const login = data => { //登录
    return instance({
        method: 'post',
        url: '/login',
        data: Qs.stringify(data)
    });
}

export const addUser = (data) => { //新增
    return instance({
        method: 'post',
        url: '/admin',
        data: Qs.stringify(data)
    });
}

export const updateUser = (data) => { //用户修改
    return instance({
        method: 'put',
        url: '/user/' + data.username,
        data: Qs.stringify(data)
    });
}

export const adminUpdateUser = (data) => { //管理员修改
    return instance({
        method: 'put',
        url: '/admin/' + data.username,
        data: Qs.stringify(data)
    });
}

export const deleteUser = (username) => { //删除
    return instance({
        method: 'delete',
        url: '/admin/' + username
    });
}

export const getUsers = (department, nickname, page, pageSize) => { //查看用户们的信息
    return instance({
        method: 'get',
        url: '/admin?department=' + department + '&nickname=' + nickname + '&page=' + page + '&pageSize=' + pageSize
    });
}

export const getUserInfo = username => { //登录获取用户信息
    return instance({
        method: 'get',
        url: '/user/' + username,
    })
}

export const createMission = data => { //任务上传
    return instance({
        method: 'post',
        url: '/mission',
        data: Qs.stringify(data)
    })
}

export const deleteMissionImg = data => { //管管理员任务图片删除
    return instance({
        method: 'delete',
        url: '/admin/mission/deleteImg',
        data: data
    })
}

export const deleteMissionAppendix = data => { //管管理员任务附件删除
    return instance({
        method: 'delete',
        url: '/admin/mission/deleteFile',
        data: data
    })
}

export const deleteMissionImgOnSite = data => { //普通用户现场图片删除
    return instance({
        method: 'delete',
        url: '/mission/deleteImg',
        data: data
    })
}

export const deleteMissionFile = data => { //任务文件删除
    return instance({
        method: 'delete',
        url: '/mission/deleteFile',
        data: data
    })
}


export const getAllDepartment = () => {
    return instance({
        method: 'get',
        url: '/admin/department'
    })
}

export const getDepartment = (departmentId) => {
    return instance({
        method: 'get',
        url: '/admin/department/' + departmentId
    })
}


export const getUser = (keyword) => { //名字模糊查询
    return instance({
        method: 'get',
        url: '/admin/user?keyword=' + keyword
    })
}

export const getMission = (page) => { //获取任务
    return instance({
        method: 'get',
        url: '/mission?page=' + page
    })
}

export const editMission = (missionId, data) => { //编辑任务
    return instance({
        method: 'put',
        url: '/mission/' + missionId,
        data: Qs.stringify(data)
    })
}

export const getMissionByPk = missionId => { //查看任务
    return instance({
        method: 'get',
        url: '/mission/' + missionId
    })
}

export const downloadFile = (directory, filename) => {
    return instance({
        method: 'get',
        url: '/admin/mission/download?directory=' + directory + '&filename=' + filename,
        responseType: 'blob' // 表明返回服务器返回的数据类型
    });
}

export const missionDelete = missionId => {          //删除核查处置任务
    return instance({
        method: 'delete',
        url: '/admin/mission/missionDelete/' + missionId
    });
}

export const commonDelete=commonId=>{           //删除通用任务
    return instance({
        method:"delete",
        url:"/admin/common/commonDelete/"+ commonId
    })
}


export const exportUser = data => {
    return instance({
        method: 'post',
        url: '/admin/user/export',
        data: data,
        responseType: 'blob' // 表明返回服务器返回的数据类型
    });
}

export const exportMission = missionId => {
    return instance({
        method: 'get',
        url: '/admin/mission/export?missionId=' + missionId,
        responseType: 'blob' // 表明返回服务器返回的数据类型
    });
}

export const getMissionBySearch = (isAdmin, keyword) => { //根据不同的用户身份查询
    if (isAdmin) {
        return instance({
            method: 'get',
            url: '/admin/mission?keyword=' + keyword
        });
    } else {
        return instance({
            method: 'get',
            url: '/mission/search/getMission?keyword=' + keyword
        });
    }
}

export const getCommonBySearch = (isAdmin, keyword) => { //根据不同的用户身份查询
    if (isAdmin) {
        return instance({
            method: 'get',
            url: '/admin/common?keyword=' + keyword
        });
    } else {
        return instance({
            method: 'get',
            url: '/common/search/getCommon?keyword=' + keyword
        });
    }
}

export const back = data => { //任务退回
    return instance({
        method: 'put',
        url: '/admin/mission/back',
        data: Qs.stringify(data)
    });
}

export const backMessage=data=>{        //生成任务退回消息
        return instance({ 
            method:"post",
            url:"/message/createUserMessage",
            data:Qs.stringify(data)
    })
}

export const createComment = data => {
    return instance({
        method: 'post',
        url: '/common',
        data: Qs.stringify(data)
    })
}

export const getCommon = page => {    
    return instance({
        method: 'get',
        url: '/common?page=' + page
    })
}

export const getCommonByPk = commonId => { //查看任务
    return instance({
        method: 'get',
        url: '/common/' + commonId
    })
}

export const showByUploadUser = commonId => { //查看任务
    return instance({
        method: 'get',
        url: '/common/upload/show?commonId=' + commonId
    })
}

export const deleteFile = data => {
    return instance({
        method: 'put',
        url: '/common/file/delete',
        data: Qs.stringify(data)
    });
}

export const updateCommon = data => {
    return instance({
        method: 'put',
        url: '/common/' + data.commonId,
        data: Qs.stringify(data)
    });
}

export const addSubTask = data => { //新增
    return instance({
        method: 'post',
        url: '/subTask',
        data: Qs.stringify(data)
    });
}

export const returnCommon = data => { //任务回传
    return instance({
        method: 'put',
        url: '/common/subTask/return',
        data: Qs.stringify(data)
    });
}

export const createAdminMessage =data=>{       //回传/补传成功后的消息提醒
    return instance({
        method:'post',
        url:'/message/createMessage',
        data:Qs.stringify(data)
    })
}

export const getAdminMessage=()=>{            //获取管理员收到的回传/补传信息
    return instance({
        method:"get",
        url:"/message/getAdminMessage"
    })
}

export const getUserMessage=()=>{           //获取用户收到的 退回 /结束 /发布信息
    return instance({
        method:"get",
        url:"/message/getUserMessage"
    })
}

export const readUserMessage=(data)=>{              //用户阅读消息
    return instance({
        method:"post",
        url:"/message/readUserMessage",
        data:Qs.stringify(data)
    })
}

export const readAdminMessage=(data)=>{             //管理端阅读信息
    return instance({
        method:"post",
        url:"/message/readAdminMessage",
        data:Qs.stringify(data)
    })
}

export const showsubTask=(subTaskId)=>{                //查询指定ID的子任务
    return instance({
        method:"get",
        url:"/subTask/showsubTask/"+subTaskId
    })
}



export const deleteCommon = data => { //任务回传附件删除
    return instance({
        method: 'put',
        url: '/common/subTask/delete',
        data: Qs.stringify(data)
    });
}

export const getAllCommonType = () => { //通用任务类型
    return instance({
        method: 'get',
        url: '/common/type/index'
    });
}

export const stopCommon = data => {
    return instance({
        method: 'put',
        url: '/common/state/stop',
        data: Qs.stringify(data)
    });
}

export const clearNew = data => {
    return instance({
        method: 'put',
        url: '/common/subTask/clear',
        data: Qs.stringify(data)
    });
}

export const expireSoonMission=data=>{
    return instance({
        method:'get',
        url:"/mission/getExpireSoonMission",
        data:Qs.stringify(data)
    })
}

export const expiringMission=data=>{
    return instance({
        method:"get",
        url:"/mission/getExpiringMission",
        data:Qs.stringify(data)
    })
}

export const expiringSubTask=()=>{
    return instance({
        method:"get",
        url:"/common/subTask/getExpireSubTask"
    })
}

export default instance


// WEBPACK FOOTER //
// ./src/api/index.js